import { buildScanIndex, deepFreezeIndex } from '@/components/views/images360/scanIndex';

/**
 * AVA-597: keeps state.scanIndex in step with the facility's projects, levels and point clouds.
 *
 * Why a plugin and not a getter: a getter reads every scan field while it builds, so its watcher
 * held ~67k reactive dependencies on a 5,059-scan facility, and every computed or render that read
 * it inherited them (a 1.5 s reopen, ~900 ms per filter change). Here the watch getter reads only the
 * array references (plus each project's images array, so an in-place push/splice rebuilds); the
 * build runs in the callback, outside dependency collection, and the result is deep-frozen so Vue
 * never walks it.
 *
 * Documented limitation (same as the old deep: false watchers): in-place edits that replace no
 * array do NOT rebuild the index, e.g. a scan's position changing on lock, or an archive flag or
 * name edited on an existing project or image object.
 *
 * Registration: src/store/index.js `plugins: [scanIndexPlugin]`; writes via the root `setScanIndex`.
 */
export default function scanIndexPlugin(store) {
  store.watch(
    (state) => [state.projects, state.levels, state.pointClouds, ...(state.projects || []).map((p) => p.images)],
    () => {
      const { projects, levels, pointClouds } = store.state;
      store.commit('setScanIndex', deepFreezeIndex(buildScanIndex({ projects, levels, pointClouds })));
    },
    { immediate: true },
  );
}
